<div *ngIf="import">
  <kendo-grid id="payrollRecordGrid" [data]="gridView" [selectable]="false" [scrollable]="'true'" [resizable]="true"
    [sortable]="true" [pageable]="true" [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
    [filter]="gridState.filter" (pageChange)="pageChange($event)" (dataStateChange)="onStateChange($event)"
    (edit)="editHandler($event)" (remove)="removeHandler($event)" (add)="addHandler()" [width]="'auto'"
    [ngStyle]="gridHeight">

    <ng-template kendoGridToolbarTemplate>
      <div class="row bottom-margin-0 width-100p">
        <div class="col l8 xl6 margin-5 left-padding-0 right-gap-15" id="action-btn">
          <!-- ADD RECORD BTN -->
          <button kendoGridAddCommand *ngIf="submitted && operators.Add" id="addRecordBtn"
            class="btn btn-fullwidth background-red right-margin-5"><span class='k-icon k-i-plus-circle'></span>Add
            Record</button>
          <!-- DWONLOAD CURRENT UPLOAD -->
          <button class="btn btn-fullwidth background-red" *ngIf="submitted"
            title="You can download the currently saved payroll infomation in its current state. The download will be in the form of a text file with the same specifications of an upload file"
            (click)="downloadFile()" id="downloadRecordBtn"><span class='k-icon k-i-download'></span>Download
            current upload</button>
          <!-- IMPORT TO EXCEL -->
          <button kendoGridExcelCommand *ngIf="!submitted" id="ExportToExcel"
            class="btn btn-fullwidth background-red"><span class="k-icon k-i-file-excel height-auto"></span>Export
            to Excel</button>
        </div>
        <div class="col s12 l4 xl6 margin-5 float-right padding-0">
          <div class="globalSearch">
            <span class="k-textbox k-space-right" style="width: 100%;">
              <input id="common-Search" class="k-text" type=text id="icon-right" placeholder="Search by Name or SSN4"
                (input)="onInput($event.target.value)" [(ngModel)]="filterValue" />
              <a class="k-icon k-i-search">&nbsp;</a>
            </span>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Mobile View -->
    <kendo-grid-column media="(max-width: 992.98px)" title="Details">
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- template for mobile -->
        <dl>
          <!-- Name -->
          <dt>
          </dt>
          <dd>
            <div class="align-left">
              <span class="bold">Name: </span>
              <span> {{ dataItem.name }}</span>
            </div>
          </dd>
          <!-- SSN 4-->
          <dt>
          </dt>
          <dd>
            <div class="align-left">
              <span class="bold">SSN 4: </span>
              {{ dataItem.lastFourSSN }}
            </div>
          </dd>
        </dl>
      </ng-template>
    </kendo-grid-column>

    <!-- EDIT AND DELETE BUTTONS -->
    <kendo-grid-command-column media="(min-width: 993px)" title="" [width]="90"
      *ngIf="submitted && (operators.Edit || operators.Delete)" id="kendoGridCommandColumn">
      <ng-template kendoGridCellTemplate>
        <div class="align-center" kendoTooltip>
          <a kendoGridEditCommand id="editBtn" *ngIf="operators.Edit">
            <span class="k-icon k-i-edit link-icon " title="Edit"></span>
          </a>
          <a kendoGridRemoveCommand id="actionBtn" *ngIf="operators.Delete">
            <span class="k-icon k-i-delete link-icon" title="Delete"></span>
          </a>
        </div>
      </ng-template>
    </kendo-grid-command-column>

    <!-- STATUS COLUMN -->
    <kendo-grid-column media="(min-width: 993px)" field="issue" title="Status" [resizable]="false" [width]="100"
      [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span class="text-red" *ngIf="dataItem.isError === 1" title={{dataItem.error}}><span
            class="k-icon k-i-error text-red"></span>Error</span>
        <span class="text-warning" *ngIf="dataItem.isError === 0 && dataItem.issue !== ''"
          title={{dataItem.issue}}><span class="k-icon k-i-warning text-warning"></span>Warning</span>
        <span class="text-green" *ngIf="dataItem.isError === 0 && dataItem.issue === ''"><span
            class="k-icon k-i-checkmark text-green"></span>Okay</span>
      </ng-template>
    </kendo-grid-column>

    <!-- SSN COLUMN -->
    <kendo-grid-column media="(min-width: 993px)" field="lastFourSSN" [resizable]="false"
      [headerStyle]="{'text-align': 'center'}" class="align-center" title="SSN 4" [width]="110">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a (click)="openRecord(dataItem);" class="clone-link">{{dataItem.lastFourSSN}}</a>
      </ng-template>
    </kendo-grid-column>
    <!-- NAME -->
    <kendo-grid-column media="(min-width: 993px)" field="name" title="Name" [width]="220"> </kendo-grid-column>
    <!-- SYSTEM CODE -->
    <kendo-grid-column media="(min-width: 993px)" field="systemCode" title="SYS" [width]="60" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-center">{{dataItem.systemCode}}</div>
      </ng-template>
    </kendo-grid-column>
    <!-- LOCATION CODE -->
    <kendo-grid-column media="(min-width: 993px)" field="locationCode" title="Location" [width]="90" [filterable]="false">
    </kendo-grid-column>
    <!-- EMP CONTRIBUTION -->
    <kendo-grid-column media="(min-width: 993px)" field="employeeContribution" title="Contribution" [width]="110"
      [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">{{dataItem.employeeContribution | currency:'USD':'symbol':'1.2-2'}}</div>
      </ng-template>
    </kendo-grid-column>
    <!-- HOURS WORKED -->
    <kendo-grid-column media="(min-width: 993px)" field="hoursWorked" title="HW" [width]="60" format="{0:n1}"
      [headerStyle]="{'text-align': 'right'}" class="align-number" [filterable]="false"></kendo-grid-column>
    <!-- STANDARD HOURS -->
    <kendo-grid-column media="(min-width: 993px)" field="standardHours" title="SH" [width]="60" format="{0:n1}"
      [headerStyle]="{'text-align': 'right'}" class="align-number" [filterable]="false"></kendo-grid-column>
    <!-- FULL TIME PERCENTAGE -->
    <kendo-grid-column media="(min-width: 993px)" field="percentFullTime" title="%FT" [width]="60"
      [headerStyle]="{'text-align': 'right'}" class="align-number" [filterable]="false"></kendo-grid-column>
    <!-- PAY PERIOD BASE SALARY -->
    <kendo-grid-column media="(min-width: 993px)" field="payPeriodBaseSalary" title="Salary" [width]="90" format="{0:c2}"
      [headerStyle]="{'text-align': 'right'}" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">{{dataItem.payPeriodBaseSalary | currency:'USD':'symbol':'1.2-2'}}</div>
      </ng-template>
    </kendo-grid-column>
    <!-- AAC -->
    <kendo-grid-column media="(min-width: 993px)" field="actualAnnualCompensation" title="AAComp" [width]="100"
      format="{0:c0}" [headerStyle]="{'text-align': 'right'}" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">{{dataItem.actualAnnualCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
      </ng-template>
    </kendo-grid-column>
    <!-- AEC -->
    <kendo-grid-column media="(min-width: 993px)" field="actualEarnableCompensation" title="AEComp" [width]="100"
      format="{0:c0}" [headerStyle]="{'text-align': 'right'}" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">{{dataItem.actualEarnableCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
      </ng-template>
    </kendo-grid-column>

    <!--EXPORT TO EXCEL-->
    <kendo-grid-excel fileName="{{importRecord.organization}}-{{importRecord.pped}}.xlsx" [fetchData]="allData">
      <kendo-excelexport-column field="ssn" title="SSN" [width]="90"></kendo-excelexport-column>
      <kendo-excelexport-column field="lastName" title="LastName" [width]="220"></kendo-excelexport-column>
      <kendo-excelexport-column field="firstName" title="FirstName" [width]="80" [filterable]="false">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="middleInitials" title="MI" [width]="90" [filterable]="false">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="systemCode" title="System" [width]="90" [filterable]="false">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="locationCode" title="Location" [width]="90" [filterable]="false">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="actualAnnualCompensation" title="AAComp" [width]="100"
        [cellOptions]="{ format: '$#,##0.00' }" [filterable]="false"></kendo-excelexport-column>
      <kendo-excelexport-column field="actualEarnableCompensation" title="AEComp" [width]="120"
        [cellOptions]="{ format: '$#,##0.00' }" [filterable]="false"></kendo-excelexport-column>
      <kendo-excelexport-column field="hoursWorked" title="HoursWorked" [width]="60" [filterable]="false">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="standardHours" title="StdHours" [width]="60" [filterable]="false">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="employeeContribution" title="Contribution" [width]="90"
        [cellOptions]="{ format: '$#,##0.00' }" [filterable]="false"></kendo-excelexport-column>
      <kendo-excelexport-column field="percentFullTime" title="%FT" [width]="50" [filterable]="false">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="payPeriodBaseSalary" title="BaseSalary" [width]="90"
        [cellOptions]="{ format: '$#,##0.00' }" [filterable]="false"></kendo-excelexport-column>
      <kendo-excelexport-column field="payPeriodEndDate" title="PPED" [width]="90" [filterable]="false"
        format="{0:MM-dd-yyyy}"></kendo-excelexport-column>
      <kendo-excelexport-column field="addressLine1" title="Address1" [width]="220" [filterable]="false">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="addressLine2" title="Address2" [width]="220" [filterable]="false">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="city" title="City" [width]="200" [filterable]="false"></kendo-excelexport-column>
      <kendo-excelexport-column field="state" title="State" [width]="90" [filterable]="false"></kendo-excelexport-column>
      <kendo-excelexport-column field="zip" title="Zip" [width]="90" [filterable]="false"></kendo-excelexport-column>
    </kendo-grid-excel>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-info></kendo-pager-info>
    </ng-template>
  </kendo-grid>
  <!-- ADD EDIT FORM -->
  <app-payroll-record-add-edit-form [userLocations]="locations" [systems]="systems"  [isNew]="isNew" [model]="editDataItem"
    [validationSetting]="validationSettings" (responseMsg)="displayResult($event)">
  </app-payroll-record-add-edit-form>
</div>

<!-- Record Detail Dialog -->
<kendo-dialog *ngIf="opened" title="Record Detail" id="recordDetailDialog" class="import-dialog" (close)="closePopup()">
  <div class="import-dialog-IE">
    <div *ngIf="isErr" class="error-container">
      <h2 class="header-tag">Errors:</h2>
      <ul class="recordIssues">
        <li *ngFor="let error of recordErrors"><span class="k-icon k-i-error text-red"></span>
          {{error}}
        </li>
      </ul>
    </div>
    <div *ngIf="isIssue" class="issue-container">
      <h2 class="header-tag">Warnings:</h2>
      <ul class="recordIssues">
        <li *ngFor="let issue of recordIssues"><span class="k-icon k-i-warning text-warning"></span>
          {{issue}}
        </li>
      </ul>
    </div>
    <br>
    <table class="keyValuePairs" aria-hidden="true">
      <tbody class="alignLeft">
        <tr>
          <th class="shaded" colspan="2">Personal Details</th>
        </tr>
        <tr>
          <th>Social Security Number</th>
          <td>{{selectedRecord.ssn}}</td>
        </tr>
        <tr>
          <th>Last Name</th>
          <td>{{selectedRecord.lastName}}</td>
        </tr>
        <tr>
          <th>First Name</th>
          <td>{{selectedRecord.firstName}}</td>
        </tr>
        <tr>
          <th>Middle Initial</th>
          <td>{{selectedRecord.middleInitials}}</td>
        </tr>
        <tr>
          <th>AddressLine1</th>
          <td>{{selectedRecord.addressLine1}}</td>
        </tr>
        <tr>
          <th>AddressLine2</th>
          <td>{{selectedRecord.addressLine2}}</td>
        </tr>
        <tr>
          <th>City</th>
          <td>{{selectedRecord.city}}</td>
        </tr>
        <tr>
          <th>State</th>
          <td>{{selectedRecord.state}}</td>
        </tr>
        <tr>
          <th class="remove-border">Zip</th>
          <td class="remove-border">{{selectedRecord.zip}}</td>
        </tr>
        <tr>
          <th class="shaded" colspan="2">Membership</th>
        </tr>
        <tr>
          <th>Location</th>
          <td>{{selectedRecord.locationCode}}</td>
        </tr>
        <tr>
          <th class="remove-border">System Code</th>
          <td class="remove-border">{{selectedRecord.systemCode}}</td>
        </tr>
        <tr>
          <th class="shaded" colspan="2">Pay</th>

        </tr>
        <tr>
          <th>Pay Period End Date</th>
          <td>{{selectedRecord.payPeriodEndDate | date: "MM/dd/yyyy"}}</td>
        </tr>
        <tr>
          <th>Actual Annual Compensation</th>
          <td>{{selectedRecord.actualAnnualCompensation | currency}}</td>
        </tr>
        <tr>
          <th>Annual Earnable Compensation</th>
          <td>{{selectedRecord.actualEarnableCompensation | currency}}</td>
        </tr>
        <tr>
          <th>Employee Contribution</th>
          <td>{{selectedRecord.employeeContribution | currency}}</td>
        </tr>
        <tr>
          <th>Pay Period Base Salary</th>
          <td>{{selectedRecord.payPeriodBaseSalary | currency}}</td>
        </tr>
        <tr>
          <th>Hours Worked</th>
          <td>{{selectedRecord.hoursWorked}}</td>
        </tr>
        <tr>
          <th>Standard Hours</th>
          <td>{{selectedRecord.standardHours}}</td>
        </tr>
        <tr>
          <th>Percentage of Time</th>
          <td>{{selectedRecord.percentFullTime }}</td>
        </tr>
      </tbody>
    </table>
    <br />
  </div>
</kendo-dialog>

<!-- Delete Payroll -->
<kendo-dialog title="Delete Record" *ngIf="deleteRecordDialog" (close)="deleteRecordDialog=false" [minWidth]="250"
  id="delete-import-dialog" class="app-dialog">
  <div class="important deleteimport">
    <div *ngIf="totalNoOfRecords > 1; else deleteImport">Do you want to permanently delete this record?</div>
    <ng-template #deleteImport>
      Deleting this final record will delete the import.
      <span> Do you want to continue? </span>
    </ng-template>
  </div>
  <div *ngIf="kendoloading">
    <div class="stroke-separator-margin-5"></div>
    <span class="k-i-loading k-icon col-md-offset-5 dialog-inner-loading"></span>
    <span class="dotLoading">Deleting</span>
  </div>
  <kendo-dialog-actions id="deleteImportDialogBtn">
    <button kendoButton class="k-button" [disabled]="kendoloading" (click)="deleteRecordDialog=false" primary="true">No</button>
    <button kendoButton class="k-button" [disabled]="kendoloading" (click)="remove('yes')" primary="true">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
